import { render, staticRenderFns } from "./ProfileSpeedboatIdentities.vue?vue&type=template&id=03900539"
import script from "./ProfileSpeedboatIdentities.vue?vue&type=script&lang=js"
export * from "./ProfileSpeedboatIdentities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports